import React from 'react';
import { withStyles } from '@mui/styles';
import { SaveButton, Toolbar } from 'react-admin';
import { stylesToolbar } from '../stylesToolbar';

const styles = () => ({
  ...stylesToolbar,
});

const ToolbarForgotPassword = ({ classes, ...props }) => {
  return (
    <Toolbar {...props} className={classes.root}>
      <SaveButton label="reset password" redirect="/login" icon={<span />} />
    </Toolbar>
  );
};

export default withStyles(styles)(ToolbarForgotPassword);
